import styled from "styled-components";

export const PartnershipsContainer = styled.div`
  .partnerships-content {
    background: ${({ theme }) => theme.card.bg.primary};
    border-radius: 6px;
    padding: 20px;

    h2 {
      font-size: 24px;
      font-weight: 500;
    }
  }

  .divider {
    height: 1px;
    background: ${({ theme }) => theme.divider.bg.primary};
  }

  .tab-content {
    margin-top: 20px;
  }
`;
